import { cn } from "@/utils/cn";

interface GetTableWrapperPropsArgs {
  scrollX?: boolean;
  scrollY?: boolean;
  hideScrollbar?: boolean;
}

export function getTableWrapperProps({
  scrollX,
  scrollY,
  hideScrollbar,
}: GetTableWrapperPropsArgs): {
  wrapperClassName: string;
} {
  const effectiveScrollX = scrollX !== false;
  const effectiveScrollY = scrollY !== false;
  const effectiveHideScrollbar = hideScrollbar === true;

  const overflowX = effectiveScrollX ? "overflow-x-auto" : "";
  const overflowY = effectiveScrollY ? "overflow-y-auto" : "";
  const hideScrollbarClass = effectiveHideScrollbar ? "hide-scrollbar" : "";

  const wrapperClassName = cn(
    "relative w-full",
    overflowX,
    overflowY,
    hideScrollbarClass
  );
  return { wrapperClassName };
}
